import { HubConnectionState } from '@microsoft/signalr'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

interface IProps {
  hubStatus?: HubConnectionState
}

export const HubConnectionStatus: React.FC<IProps> = ({ hubStatus }) => {
  const [status, setStatus] = useState<HubConnectionState>()

  useEffect(() => {
    setStatus(hubStatus)
  }, [hubStatus])

  return (
    <div>
      <div className='flex items-center justify-between gap-[10px] text-[0.75rem] bg-primary-content/5 pl-[10px] pr-[3px] py-[3px] rounded-[20px] h-[25px] min-w-[110px]'>
        <div className='grow text-center'>
          {status}
          {(status === HubConnectionState.Connecting ||
            status === HubConnectionState.Reconnecting ||
            status === HubConnectionState.Disconnecting) &&
            '...'}
        </div>
        <span className='relative flex w-[20px] min-w-[20px] h-[20px] min-h-[20px] rounded-full'>
          <span
            className={classNames(
              'absolute inline-flex h-full w-full rounded-full opacity-75',
              status && status !== HubConnectionState.Disconnected && 'animate-ping',
              (!status || status === HubConnectionState.Disconnected) && 'bg-error border-error-content/10',
              !status || (status === HubConnectionState.Connected && 'bg-success border-success-content/10'),
              (status === HubConnectionState.Connecting ||
                status === HubConnectionState.Reconnecting ||
                status === HubConnectionState.Disconnecting) &&
                'bg-warning border-warning-content/10'
            )}
          />
          <span
            className={classNames(
              'relative inline-flex rounded-full w-[20px] min-w-[20px] h-[20px] min-h-[20px]',
              (!status || status === HubConnectionState.Disconnected) && 'bg-error border-error-content/10',
              !status || (status === HubConnectionState.Connected && 'bg-success border-success-content/10'),
              (status === HubConnectionState.Connecting ||
                status === HubConnectionState.Reconnecting ||
                status === HubConnectionState.Disconnecting) &&
                'bg-warning border-warning-content/10'
            )}
          />
        </span>
      </div>
    </div>
  )
}
